import { Colors } from '@lichtblick/theme';
import {
  AppointmentCalendarItemPayloadModel,
  BlockerCalendarItemPayloadModel,
  CalendarItemPayloadModel,
  GetCalendarItems_V1Query,
  GetTeamsPayloadModel,
} from '@lichtblick/types';

export type TimelineGroup = { bgColor: string; id: number; title: string };
export type TimelineItem = {
  className: string;
  end: number;
  group: number;
  id: string;
  itemProps?: {
    appointmentType?: string | null;
    'data-tip'?: string | null;
    isBinding?: boolean | null;
    workOrderName?: string | null;
  };
  start: number;
  title: string | undefined | null;
};

export const createTimelineItems = (
  teams: Array<GetTeamsPayloadModel>,
  appointments: NonNullable<GetCalendarItems_V1Query['getCalendarItems_V1']['data']>,
) => {
  const items: TimelineItem[] = [];
  const groups: TimelineGroup[] = [];

  for (const team of teams) {
    const branchOfficenName = team.branchOffice?.name?.split(' ')?.[1];

    groups.push({
      id: team.id,
      title: `${team.name} (${branchOfficenName})`,
      bgColor: Colors.white,
    });
    const filteredAppointments = appointments.filter(
      (appointment) => (appointment as CalendarItemPayloadModel)?.teams?.[0]?.id === team.id,
    );

    for (const appointment of filteredAppointments as CalendarItemPayloadModel[]) {
      if (appointment.__typename === 'AppointmentCalendarItemPayloadModel') {
        const apt = appointment as AppointmentCalendarItemPayloadModel;

        items.push({
          id: `${apt.id}_${team.id}`,
          group: team.id ?? '',
          title: apt.workflowDefinition?.name,
          start: new Date(apt.startAtUtc).getTime(),
          end: new Date(apt.endAtUtc).getTime(),
          className: 'item-weekend',
          itemProps: {
            'data-tip': apt.workflowDefinition?.name,
            appointmentType: apt.workflowDefinition?.name,
            workOrderName: apt.workOrder?.name,
            isBinding: apt.isBinding ?? false,
          },
        });
      }

      if (appointment.__typename === 'BlockerCalendarItemPayloadModel') {
        const apt = appointment as BlockerCalendarItemPayloadModel;

        items.push({
          id: `${apt.id}_${team.id}`,
          group: team.id ?? '',
          title: apt.reason?.title,
          start: new Date(apt.startAtUtc).getTime(),
          end: new Date(apt.endAtUtc).getTime(),
          className: 'item-weekend',
          itemProps: {
            'data-tip': 'blocker',
            appointmentType: 'blocker',
          },
        });
      }
    }
  }

  return {
    groups: groups,
    items: items,
  };
};
